import { colors } from '../../Colors/colors'

export const navbarTheme = {
   light: {
      navbar: {
         bgColor: 'bg-base-white',
         borderColor: 'border-gray-200'
      },
      defaultNavItem: {
         bgColor: 'bg-base-white',
         borderColor: 'border-gray-200',
         selectedBgColor: 'bg-primary-50',
         textColor: 'text-gray-700',
         selectedTextColor: 'text-primary-600',
         hoverBgColor: 'bg-gray-50'
      },
      childNavItem: {
         bgColor: 'bg-base-white',
         borderColor: 'border-gray-200',
         selectedBgColor: 'bg-primary-50',
         textColor: 'text-gray-700',
         selectedTextColor: 'text-primary-600',
         hoverBgColor: 'bg-gray-50'
      },
      defaultExpandableNavItem: {
         bgColor: 'bg-base-white',
         borderColor: 'border-gray-200',
         selectedBgColor: 'bg-primary-50',
         textColor: 'text-gray-700',
         selectedTextColor: 'text-primary-600',
         hoverBgColor: 'bg-gray-50',
         chevronIconColor: colors['gray-500']
      },
      header: {
         searchIconColor: colors['gray-500'],
         searchTextColor: 'text-gray-500',
         searchShortcutBgColor: 'bg-gray-50',
         searchShortcutTextColor: 'text-gray-600',
         searchButtonBgColor: 'bg-gray-100',
         searchShortcutBorderColor: 'border-gray-300'
      },
      footer: {
         borderTopColor: 'border-gray-200',
         hoverBgColor: 'hover:bg-gray-50'
      },
      footerPopover: {
         optionTextColor: 'text-gray-700',
         hoverBgColor: 'hover:bg-gray-50',
         borderColor: 'border-gray-200',
         menuOpenedStateBgColor: 'bg-gray-50',
         userCircleIconColor: colors['gray-700'],
         helpCircleIconColor: colors['gray-700'],
         alertOctagonIconColor: colors['gray-700'],
         messageDotsIconColor: colors['gray-700'],
         logOutIconColor: colors['gray-700'],
         linkExternalIconColor: colors['gray-500'],
         dotsHorizontalIconColor: colors['gray-500'],
         plusIconColor: colors['gray-500'],
         closeIconColor: colors['error-500'],
         loaderIconColor: colors['gray-500']
      },
      option: {
         optionTextColor: 'text-gray-700',
         hoverBgColor: 'hover:bg-gray-50',
         borderColor: 'border-gray-200',
         dividerColor: 'bg-gray-300',
         deleteActionTextColor: 'text-error-600'
      },
      navActions: {
         hoverBgColor: 'hover:bg-gray-200',
         menuOpenedStateBgColor: 'bg-gray-200',
         borderColor: 'border-gray-200',
         bgColor: 'bg-gray-50',
         selectedBgColor: 'bg-primary-50'
      },
      sectionNavItem: {
         borderTopColor: 'border-gray-300',
         sectionNameColor: 'text-gray-400'
      },
      sectionExpandableNavItem: {
         textColor: 'text-gray-700',
         selectedTextColor: 'text-primary-600',
         hoverBgColor: 'bg-gray-50'
      },
      sectionNavigableNavItem: {
         textColor: 'text-gray-700',
         hoverBgColor: 'bg-gray-50'
      },
      childSectionExpandableNavItem: {
         textColor: 'text-gray-700',
         selectedTextColor: 'text-primary-600',
         hoverBgColor: 'bg-gray-50',
         selectedBgColor: 'bg-primary-50'
      },
      subSectionNavItem: {
         dividerColor: 'bg-gray-300',
         sectionNameColor: 'text-gray-400',
         actionHoverBgColor: 'hover:bg-gray-200'
      },
      adminNavbar: {
         borderColor: 'border-gray-300',
         chevronLeftIconColor: colors['primary-600'],
         bgColor: 'bg-gray-50',
         addPipelineIconColor: colors['gray-600'],
         titleColor: 'text-gray-900'
      },
      createPipelineModel: {
         createPipelineContainerBgColor: 'bg-base-white',
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-600',
         nextBtnIconColor: colors['base-white'],
         backBtnIconColor: colors['gray-600'],
         defaultLabelColor: 'text-gray-700'
      },
      attendance: {
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-600',
         clockInCardBorderColor: 'border-gray-300',
         footerDetailsTextColor: 'text-gray-600'
      },
      pipelineTemplateConfig: {
         cardColors: 'border-gray-100 bg-gray-50'
      }
   },
   dark: {}
}
